import Fetch, { V1 } from 'Util/fetcher';

const DISPLAY_TNC = 'DISPLAY_TNC';

export function onDoDisplayTnc(payload) {
  return {
    type: DISPLAY_TNC,
    payload,
  };
}

const GET_BANK_LIST = 'GET_BANK_LIST';
const ON_SELECTED_BANK = 'ON_SELECTED_BANK';
const SET_ACCOUNT_NAME = 'SET_ACCOUNT_NAME';

export function onDoBankSelected(payload) {
  return {
    type: ON_SELECTED_BANK,
    payload,
  };
}

export function onDoSetAccountName(payload) {
  return {
    type: SET_ACCOUNT_NAME,
    payload,
  };
}

function onDoSetBank(payload) {
  return {
    type: GET_BANK_LIST,
    payload,
  };
}

export const onDoGetBankList = () => (dispatch) => {
  Fetch.get(`${V1}bank-account/banks/`).then((resp) => {
    if (resp.ok && resp.json.results) {
      dispatch(onDoSetBank(resp.json.results));
    }
  });
};

const ON_REQUEST_VALIDATE_BANK_ACCOUNT = 'ON_REQUEST_VALIDATE_BANK_ACCOUNT';
const ON_REQUEST_VALIDATE_BANK_ACCOUNT_SUCCESS = 'ON_REQUEST_VALIDATE_BANK_ACCOUNT_SUCCESS';
const ON_REQUEST_VALIDATE_BANK_ACCOUNT_FAILURE = 'ON_REQUEST_VALIDATE_BANK_ACCOUNT_FAILURE';

function onRequesValidateBankAccount() {
  return {
    type: ON_REQUEST_VALIDATE_BANK_ACCOUNT,
  };
}

function onRequesValidateBankAccountSuccess(payload) {
  return {
    type: ON_REQUEST_VALIDATE_BANK_ACCOUNT_SUCCESS,
    payload,
  };
}

function onRequesValidateBankAccountFailure(payload) {
  return {
    type: ON_REQUEST_VALIDATE_BANK_ACCOUNT_FAILURE,
    payload,
  };
}

export const onDoRequesValidateBankAccount = (payload) => (dispatch) => {
  dispatch(onRequesValidateBankAccount());
  Fetch.get(`${V1}stock/verify-bank/${payload.accNumber}/${payload.accName}/CENAIDJA`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequesValidateBankAccountSuccess(resp.json));
      } else {
        dispatch(onRequesValidateBankAccountFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequesValidateBankAccountFailure(error.message));
    });
};

const INITIAL_STATE = {
  accountName: '',
  selectedBank: null,
  validateBankAcc: null,
  validateBankAccSuccess: null,
  validateBankAccError: null,
  verifyBankAccountLoading: null,
  verifyBankAccount: null,
  verifyBankAccountError: null,
  displayTnc: false,
};

const kycDukcapil = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_ACCOUNT_NAME: {
      return {
        ...state,
        accountName: action.payload,
      };
    }
    case ON_SELECTED_BANK: {
      return {
        ...state,
        selectedBank: action.payload,
      };
    }
    case GET_BANK_LIST: {
      return {
        ...state,
        bankData: action.payload,
      };
    }
    case ON_REQUEST_VALIDATE_BANK_ACCOUNT:
      return {
        ...state,
        validateBankAcc: true,
        validateBankAccSuccess: null,
        validateBankAccError: null,
      };
    case ON_REQUEST_VALIDATE_BANK_ACCOUNT_SUCCESS:
      return {
        ...state,
        validateBankAcc: true,
        validateBankAccSuccess: action.payload,
        validateBankAccError: null,
      };
    case ON_REQUEST_VALIDATE_BANK_ACCOUNT_FAILURE:
      return {
        ...state,
        validateBankAcc: true,
        validateBankAccSuccess: null,
        validateBankAccError: action.payload,
      };
    case DISPLAY_TNC:
      return {
        ...state,
        displayTnc: action.payload,
      };
    default:
      return state;
  }
};

export default kycDukcapil;
